import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-archivedata',
  templateUrl: './archivedata.component.html',
  styleUrls: ['./archivedata.component.scss']
})
export class ArchivedataComponent implements OnInit {

  projectId: string = '';
  isSubmitting: boolean = false;
  currentAction: string = '';

  // Archive timer
  archiveStartTime: number = 0;
  archiveElapsedSeconds: number = 0;
  archiveTimer: any = null;

  constructor(
    private userService: UserService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
  }

  Archive(form: NgForm): void {

    // Validate Project ID
    if (!this.projectId || this.projectId.trim() === '') {

      if (form.controls['projectId']) {
        form.controls['projectId'].markAsTouched();
      }

      this.toastr.warning(
        'Please enter Project Id.',
        '',
        {
          progressBar: true,
          timeOut: 4000
        }
      );
      return;
    }

    var projectIdValue = this.projectId.trim();

    this.isSubmitting = true;
    this.currentAction = 'archive';

    // Start archive timer
    this.archiveStartTime = new Date().getTime();
    this.archiveElapsedSeconds = 0;

    if (this.archiveTimer) {
      clearInterval(this.archiveTimer);
    }

    this.archiveTimer = setInterval(() => {
      if (this.isSubmitting && this.currentAction === 'archive') {
        var currentTime = new Date().getTime();
        this.archiveElapsedSeconds =
          Math.floor(
            (currentTime - this.archiveStartTime) / 1000
          );
      }
    }, 1000);

    console.log('Archive Project ID:', projectIdValue);

    this.userService.archivesurvey(projectIdValue)
      .subscribe(

        // SUCCESS
        (data: any) => {

          console.log('Archive API Response:', data);

          this.isSubmitting = false;
          this.currentAction = '';

          // Stop archive timer
          if (this.archiveTimer) {
            clearInterval(this.archiveTimer);
            this.archiveTimer = null;
          }

          if (data && data.success === true) {
            this.toastr.success(
              data.message || 'Archive Successfully',
              '',
              {
                progressBar: true,
                timeOut: 5000
              }
            );

            this.projectId = '';
            form.resetForm();

          } else {
            var message = 'Unable to archive client survey.';

            if (data && data.message) {
              message = data.message;
            }
            this.toastr.warning(
              message,
              'Archive Failed',
              {
                progressBar: true,
                timeOut: 6000
              }
            );
          }
        },

        // ERROR
        (error: any) => {

          console.error('Archive API Error:', error);

          this.isSubmitting = false;
          this.currentAction = '';

          // Stop archive timer
          if (this.archiveTimer) {
            clearInterval(this.archiveTimer);
            this.archiveTimer = null;
          }

          var errorMessage = 'Error while archiving client survey.';

          /*
           * Your API returns:
           *
           * {
           *   success: false,
           *   message: "Error while archiving client survey.",
           *   error: "Timeout expired..."
           * }
           */

          if (error && error.error) {

            // API message
            if (error.error.message) {
              errorMessage = error.error.message;
            }

            // SQL error / timeout
            if (error.error.error) {

              var sqlError =
                error.error.error.toString();

              console.error(
                'SQL/API Error Detail:',
                sqlError
              );

              // SQL timeout
              if (
                sqlError
                  .toLowerCase()
                  .indexOf('timeout') !== -1
              ) {
                errorMessage =
                  'Archive operation timed out. ' +
                  'The server is still processing the data ' +
                  'or the operation took too long.';
              }
              else if (!error.error.message) {
                errorMessage = sqlError;
              }
            }
          }

          // HTTP status handling
          if (error && error.status === 401) {
            errorMessage = 'Your session has expired. Please login again.';
          }
          else if (error && error.status === 403) {
            errorMessage = 'You are not authorized to archive this data.';
          }
          else if (error && error.status === 404) {
            errorMessage = 'Archive API was not found.';
          }
          else if (error && error.status === 500) {

            /*
             * Keep the API message if available.
             * SQL detail is logged in console.
             */

            if (
              error.error &&
              error.error.message
            ) {
              errorMessage =
                error.error.message;
            }
          }

          this.toastr.error(
            errorMessage,
            'Archive Failed',
            {
              progressBar: true,
              timeOut: 10000
            }
          );
        }
      );
  }

  // Format archive timer as MM:SS
  getArchiveTime(): string {

    var minutes = Math.floor(this.archiveElapsedSeconds / 60);
    var seconds = this.archiveElapsedSeconds % 60;

    var minuteText =
      minutes < 10
        ? '0' + minutes
        : minutes.toString();

    var secondText =
      seconds < 10
        ? '0' + seconds
        : seconds.toString();

    return minuteText + ':' + secondText;
  }
}

